import React from 'react';
import { string } from 'prop-types';

const ArrowBlue = ({ color = '#4A90E2', ...rest }) => (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" {...rest}>
        <path
            d="M15.7071 8.20711C16.0976 7.81658 16.0976 7.18342 15.7071 6.79289L9.34315 0.428932C8.95262 0.0384078 8.31946 0.0384078 7.92893 0.428932C7.53841 0.819457 7.53841 1.45262 7.92893 1.84315L13.5858 7.5L7.92893 13.1569C7.53841 13.5474 7.53841 14.1805 7.92893 14.5711C8.31946 14.9616 8.95262 14.9616 9.34315 14.5711L15.7071 8.20711ZM0 8.5H15V6.5H0V8.5Z"
            fill={color}
        />
    </svg>
);

ArrowBlue.propTypes = {
    color: string
};

export default ArrowBlue;
